import {modalManager} from "./ModalManager";

export class ModalPlugin {
    public install(Vue) {
        Vue.prototype.$modalManager = modalManager;
    }
}
